import React from 'react';
import { getCoverKey } from 'application/components/utils';
import styles from './index.module.scss';

interface Props {
  link?: string;
  title: string;
}

const MAX_DEFAULT_COVERS_COUNT = 4;

const StreamPreviewItemPoster = (props: Props) => {
  const { link, title } = props;

  if (!link) {
    return (
      <div
        className={styles.Poster}
        data-hash={getCoverKey(title, MAX_DEFAULT_COVERS_COUNT)}
      />
    );
  }

  return (
    <img
      src={link}
      alt=""
      loading="lazy"
      className={styles.Poster}
    />
  );
};

export default StreamPreviewItemPoster;
